
export default function (state) {
    var re = /^(([a-zA-Z0-9^<>()_\-\!\#\$\%\&\*\/\=\?\^\{\|\}\~\/'\/`\[\]\\.\+,;:\s@"]+(\+\.[a-zA-Z0-9^<>()\[\]\\.,;:\s@"]+)*)|("[a-zA-Z0-9]+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return function (value) {
        return re.test(value)
    }
}
